import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { MediaTextMosaicDSWidget } from './media-text-mosaic-ds-widget'
import { MediaTextMosaicWidgetLegacy } from './media-text-mosaic-widget-legacy'

import type { MediaTextMosaicWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

// Router: DS branch when the Design System gate is active, else the legacy widget.
const MediaTextMosaicWidgetComponent = (props: PLTypedWidgetProps<MediaTextMosaicWidgetData>) => {
  if (shouldUseDesignSystem()) {
    return <MediaTextMosaicDSWidget {...props} />
  }
  return <MediaTextMosaicWidgetLegacy {...props} />
}

export const MediaTextMosaicWidget: PLTypedWidgetInterface<MediaTextMosaicWidgetData, WidgetType.MEDIA_TEXT_MOSAIC> = {
  id: WidgetType.MEDIA_TEXT_MOSAIC,
  errorBoundary: PLBaseErrorBoundary,
  render: MediaTextMosaicWidgetComponent,
}
